import { useEffect, useState } from 'react';
import ValidatedInput, { ValidatedState } from '../../../components/custom-input/ValidatedInput';
import { toastMessages } from '../../../constants/errorMessages';
import { ANIMAL_CONSTANTS, BUTTON_CONSTANTS, LABEL_CONSTANTS } from '../../../constants/common';
import { showToast } from '../../../services/toast.service';
import { Validators } from '../../../types/enums';
import { Species } from '../../../types/interfaces';
import { updateSpecies } from '../../../api/speciesApi';

type EditSpeciesModalProps = {
  close: () => void;
  species: Species;
};

const EditSpeciesModal = ({ close, species }: EditSpeciesModalProps): JSX.Element => {
  const [nameInput, setNameInput] = useState<ValidatedState>({ valid: true, value: species.name });
  const [activeInput, setActiveInput] = useState<boolean>(species.active === true);
  const [validate, setValidate] = useState<boolean>(false);

  const [submit, setSubmit] = useState<boolean>(false);
  useEffect(() => {
    const action = async () => {
      try {
        await updateSpecies(species.speciesId!, { name: nameInput.value, active: activeInput });
        showToast.success(toastMessages.SPECIES_UPDATE_SUCCESS);
      } catch {
        showToast.success(toastMessages.SPECIES_UPDATE_FAIL);
      } finally {
        setSubmit(false);
        close();
      }
    };
    if (submit) {
      action();
    }
  }, [submit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidate(true);
    if (nameInput.valid) {
      setSubmit(true);
    }
  };
  return (
    <div className="management-columns-modal">
      <form onSubmit={handleSubmit}>
        <h2>{ANIMAL_CONSTANTS.EDIT_SPECIES}</h2>
        <p>{ANIMAL_CONSTANTS.EDIT_SPECIES_HEADER}</p>
        <ValidatedInput
          useId="name-input-field"
          type="text"
          label={'Species Name'}
          validate={validate}
          validatedStateForAutoFill={nameInput}
          setValidatedState={setNameInput}
          validators={[Validators.REQUIRED]}
        />
        <div className="form-row">
          <label htmlFor="active-checkbox">{LABEL_CONSTANTS.ACTIVE}</label>
          <div className="input-container">
            <input
              id="active-checkbox"
              type="checkbox"
              defaultChecked={species.active}
              onChange={e => setActiveInput(e.target.checked)}
            />
          </div>
        </div>
        <div className="flex-right">
          <button type="button" className="small green inverted button" onClick={close}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          &emsp;
          <button type="submit" className={nameInput.valid ? 'small green button' : 'small green button disabled'}>
            {BUTTON_CONSTANTS.UPDATE}
          </button>
        </div>
      </form>
    </div>
  );
};
export default EditSpeciesModal;
